import React from "react";
import { styled } from "@mui/system";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import { FormControlLabelProps as FormControlLabelPropsMUI } from "@mui/material/FormControlLabel";
export interface FormControlLabelProps extends FormControlLabelPropsMUI {}

export const FormControlLabel: (props: FormControlLabelProps) => JSX.Element =
  styled(
    React.forwardRef<HTMLSpanElement, FormControlLabelProps>((props, ref) => (
      <MUIFormControlLabel ref={ref} {...props} />
    )),
    {
      name: "FormControlLabel",
      slot: "Root",
      overridesResolver: (props, styles) => []
    }
  )(({ theme }) => ({
    "&.MuiFormControlLabel-root .MuiTypography-root.MuiFormControlLabel-label":
      {
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: 14
      }
  }));
